import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'helpers/CSSModulesUtil'
import Body from 'components/typography/body2/index'
import { nest } from 'recompose'

import styles from './styles.scss'

const Record = (props) => (
  <div class={styles.recordLabel}>
    { props.children }
  </div>
)

const withStyle = CSSModules(styles)

export default nest(Record, Body)
